<div
  class="rich-text-editor align-items-start flex-column"
  [formGroup]="parentFormGroup"
>
  <div class="pb-2" *ngIf="formElementModel.label">
    {{ formElementModel.label + asterisk }}
  </div>
  <mat-form-field class="w-100" appearance="fill">
    <mat-rich-text-editor
      class="mat-rich-text-editor"
      [formControlName]="formElementModel.id"
      [styles]="{ height: matRichTextEdtorStyleHeight }"
      [placeholder]="
        formElementModel.placeholder ? formElementModel.placeholder : ''
      "
      [modules]="matRichTextEditorOptions"
    >
    </mat-rich-text-editor>
  </mat-form-field>
  <app-validation-error
    [control]="control"
    [formElementModel]="formElementModel"
  ></app-validation-error>
</div>
